import { z } from 'zod';

interface manageTagSchemaType {
  description: string;
  name: string;
  buildings: string;
}

export const manageTagSchema = z.object({
  description: z.string().nonempty({
    message: "Can't be empty",
  }),
  name: z.string().trim().min(2),
  buildings: z
    .array(
      z.object({ name: z.string(), value: z.union([z.string(), z.number()]) })
    )
    .min(1),
});

export const manageTagControlNames: manageTagSchemaType = {
  name: 'name',
  description: 'description',
  buildings: 'buildings',
};

export type ManageTagSchemaType = z.infer<typeof manageTagSchema>;
